/** Country / nationality label → ISO 3166-1 alpha-2 for flag emoji. */
const NAME_TO_ISO = {
  england: 'GB',
  scotland: 'GB',
  wales: 'GB',
  'northern ireland': 'GB',
  'united kingdom': 'GB',
  britain: 'GB',
  spain: 'ES',
  france: 'FR',
  germany: 'DE',
  italy: 'IT',
  portugal: 'PT',
  netherlands: 'NL',
  'the netherlands': 'NL',
  holland: 'NL',
  belgium: 'BE',
  brazil: 'BR',
  argentina: 'AR',
  uruguay: 'UY',
  colombia: 'CO',
  chile: 'CL',
  mexico: 'MX',
  usa: 'US',
  'united states': 'US',
  canada: 'CA',
  japan: 'JP',
  'south korea': 'KR',
  korea: 'KR',
  china: 'CN',
  australia: 'AU',
  denmark: 'DK',
  sweden: 'SE',
  norway: 'NO',
  finland: 'FI',
  poland: 'PL',
  croatia: 'HR',
  serbia: 'RS',
  switzerland: 'CH',
  austria: 'AT',
  turkey: 'TR',
  greece: 'GR',
  ukraine: 'UA',
  russia: 'RU',
  ireland: 'IE',
  'republic of ireland': 'IE',
  morocco: 'MA',
  senegal: 'SN',
  nigeria: 'NG',
  ghana: 'GH',
  cameroon: 'CM',
  "cote d'ivoire": 'CI',
  'ivory coast': 'CI',
  egypt: 'EG',
  algeria: 'DZ',
  tunisia: 'TN',
  'south africa': 'ZA',
  ecuador: 'EC',
  peru: 'PE',
  venezuela: 'VE',
  bolivia: 'BO',
  'costa rica': 'CR',
  jamaica: 'JM',
  honduras: 'HN',
  panama: 'PA',
  israel: 'IL',
  iran: 'IR',
  iraq: 'IQ',
  saudi: 'SA',
  'saudi arabia': 'SA',
  qatar: 'QA',
  uae: 'AE',
  'united arab emirates': 'AE',
  india: 'IN',
  indonesia: 'ID',
  thailand: 'TH',
  vietnam: 'VN',
  georgia: 'GE',
  armenia: 'AM',
  azerbaijan: 'AZ',
  iceland: 'IS',
  hungary: 'HU',
  czech: 'CZ',
  'czech republic': 'CZ',
  slovakia: 'SK',
  slovenia: 'SI',
  romania: 'RO',
  bulgaria: 'BG',
  bosnia: 'BA',
  'bosnia and herzegovina': 'BA',
  montenegro: 'ME',
  albania: 'AL',
  kosovo: 'XK',
  luxembourg: 'LU',
  malta: 'MT',
  cyprus: 'CY',
  estonia: 'EE',
  latvia: 'LV',
  lithuania: 'LT',
  belarus: 'BY',
  moldova: 'MD',
  'north macedonia': 'MK',
  macedonia: 'MK',
  'dr congo': 'CD',
  congo: 'CG',
  zambia: 'ZM',
  zimbabwe: 'ZW',
  kenya: 'KE',
  mali: 'ML',
  guinea: 'GN',
  'burkina faso': 'BF',
  togo: 'TG',
  benin: 'BJ',
  gabon: 'GA',
  angola: 'AO',
  mozambique: 'MZ',
  namibia: 'NA',
  botswana: 'BW',
  uganda: 'UG',
  tanzania: 'TZ',
  ethiopia: 'ET',
  sudan: 'SD',
  libya: 'LY',
  lebanon: 'LB',
  syria: 'SY',
  jordan: 'JO',
  palestine: 'PS',
  kuwait: 'KW',
  oman: 'OM',
  bahrain: 'BH',
  yemen: 'YE',
  afghanistan: 'AF',
  pakistan: 'PK',
  bangladesh: 'BD',
  nepal: 'NP',
  philippines: 'PH',
  malaysia: 'MY',
  singapore: 'SG',
  'new zealand': 'NZ',
  paraguay: 'PY',
};

export function countryToIso(country) {
  const key = String(country || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  if (!key) return null;
  if (NAME_TO_ISO[key]) return NAME_TO_ISO[key];
  if (key.length === 2) return key.toUpperCase();
  return null;
}

/** Regional-indicator flag emoji from country name or ISO code. */
export function countryFlagEmoji(country) {
  const iso = countryToIso(country);
  if (!iso || iso.length !== 2) return null;
  const upper = iso.toUpperCase();
  return String.fromCodePoint(
    ...[...upper].map((c) => 0x1f1e6 - 65 + c.charCodeAt(0))
  );
}
